<section class="dashboard_content_sec">
  <div class="dashboard_bred_crumb">
    <ul>
      <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
      <li [routerLink]="idValue ? ['../../list'] : ['../list'] ">Pre Owned Supplies</li>
      <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
      <li> {{ idValue ? 'Edit': 'Add' }} </li>
    </ul>
  </div>
  <!-- ADD-PRODUCT-BODY -->
  <section class="supplies_form_sec presupplies_form_sec">
    <form class="form-section supplies_add_form" [formGroup]="secondHandSupplyForm" (ngSubmit)="addSupply('DRAFT')">
      <div class="add_supplies_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
        fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">
        <div class="add_supplies_column" fxLayout="column" fxFlex="100" fxFlexFill>
          <div class="supplies_left">
            <div class="form_box">
              <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">
                <div class="mobile_mn_0" fxLayout="column" fxFlex="50" fxFlexFill>
                  <!-- Product Name-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for=""> Product Title
                      <span class="star" style="display: inline-block !important;">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter title" formControlName="title" (change)="trimMe(title)" />
                        <mat-error *ngIf="title.invalid && ( title.dirty || title.touched )">
                          <span>Product title is required</span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Sub-Category-SELECT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Select sub Category
                      <!--<span class="star" style="display: inline-block !important;">*</span>-->
                    </label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <mat-select placeholder="Select sub category" formControlName="supply_sub_category_id">
                          <mat-option>
                            <ngx-mat-select-search [formControl]="subCategoryFilterCtrl"
                              placeholderLabel="Find sub category..." [noEntriesFoundLabel]="null">
                            </ngx-mat-select-search>
                          </mat-option>
                          <ng-container
                            *ngIf="supplySubCategoryList | subCategory : supply_category_id.value: subCategoryFilterCtrl.value as supply_sub_category_list; else noSupplySubCategoryListTemplate">
                            <mat-option *ngFor="let single of supply_sub_category_list" [value]="single.id">
                              {{single.name}}
                            </mat-option>
                            <ng-container *ngIf="!supply_sub_category_list.length"
                              [ngTemplateOutlet]="noSupplySubCategoryListTemplate"></ng-container>
                          </ng-container>
                          <ng-template #noSupplySubCategoryListTemplate>
                            <mat-option>
                              <button type="button" class="btn btn-sm select_add_btn" mat-button
                                (click)="addSupplySubCategoryDialog()">Add new sub category</button>
                            </mat-option>
                          </ng-template>
                        </mat-select>
                       <!-- <mat-error
                          *ngIf="supply_sub_category_id.invalid && ( supply_sub_category_id.dirty || supply_sub_category_id.touched )">
                          <span>Sub category is required</span>
                        </mat-error>-->
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- SKU Number-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">SKU Code / Item Code
                      <span class="star" style="display: inline-block !important;">*</span>
                    </label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter sku number" formControlName="sku" (change)="trimMe(sku)">
                        <mat-error *ngIf="sku.invalid && ( sku.dirty || sku.touched )">
                          <span>Sku code/ Item code is required</span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="mobile_mn_0" fxLayout="column" fxFlex="50" fxFlexFill>
                  <!-- Category-SELECT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for=""> Select Category
                      <!--<span class="star" style="display: inline-block !important;">*</span>-->
                    </label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <mat-select placeholder="Select category" formControlName="supply_category_id">
                          <mat-option>
                            <ngx-mat-select-search [formControl]="categoryFilterCtrl"
                              placeholderLabel="Find category..." [noEntriesFoundLabel]="'no matching category found'">
                            </ngx-mat-select-search>
                          </mat-option>
                          <ng-container
                            *ngIf="supplyCategoryList | category : categoryFilterCtrl.value as supply_category_list; else noSupplyCategoryListTemplate">
                            <mat-option *ngFor="let single of supply_category_list" [value]="single.id">
                              {{single.name}}
                            </mat-option>
                            <ng-container *ngIf="!supply_category_list.length"
                              [ngTemplateOutlet]="noSupplyCategoryListTemplate"></ng-container>
                          </ng-container>
                          <ng-template #noSupplyCategoryListTemplate>
                            <mat-option>
                              <button type="button" class="btn btn-sm select_add_btn" mat-button
                                (click)="addSupplyCategoryDialog()">Add new category</button>
                            </mat-option>
                          </ng-template>
                        </mat-select>
                        <!--<mat-error
                          *ngIf="supply_category_id.invalid && ( supply_category_id.dirty || supply_category_id.touched )">
                          <span>Category is required</span>
                        </mat-error>-->
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Name-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for=""> Select Brand
                    <!-- <span class="star" style="display: inline-block !important;">*</span>--> 
                    </label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <mat-select placeholder="Select Brand" formControlName="supply_brand_id">
                          <mat-option>
                            <ngx-mat-select-search [formControl]="brandFilterCtrl" placeholderLabel="Find brand..."
                              [noEntriesFoundLabel]="'no matching brand found'"></ngx-mat-select-search>
                          </mat-option>
                          <ng-container
                            *ngIf="supplyBrandList | brand : brandFilterCtrl.value as supply_brand_list; else noSupplyBrandListTemplate">
                            <mat-option *ngFor="let single of supply_brand_list" [value]="single.id">
                              {{single.name}}
                            </mat-option>
                            <ng-container *ngIf="!supply_brand_list.length"
                              [ngTemplateOutlet]="noSupplyBrandListTemplate"></ng-container>
                          </ng-container>
                          <ng-template #noSupplyBrandListTemplate>
                            <mat-option>
                              <button type="button" class="btn btn-sm select_add_btn" mat-button
                                (click)="addSupplyBrandDialog()">Add new brand </button>
                            </mat-option>
                          </ng-template>
                        </mat-select>
                        <!--<mat-error
                          *ngIf="supply_brand_id.invalid && ( supply_brand_id.dirty || supply_brand_id.touched )">
                          <span>Brand is required</span>
                        </mat-error>-->
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Request for Featured ?-INPUT -->
                  <!-- <div class="custom-form-group">
                    <label class="custom-label" for=""> Is Featured ? <span class="star">*</span></label>
                    <div class="custom-form-control custom-tabs">
                      <mat-button-toggle-group name="Featured" formControlName="is_featured">
                        <mat-button-toggle [value]="true" class="yes">Yes</mat-button-toggle>
                        <mat-button-toggle [value]="false" class="no">No</mat-button-toggle>
                      </mat-button-toggle-group>
                    </div>
                  </div>-->
                </div>
              </div>
                 <!-- Specifications -->
              <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
              fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">
              <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100"
                fxFlex.xs="100" fxFlexFill>
                <!-- Short Description-INPUT -->
                <div class="custom-form-group mb-20">
                  <label class="custom-label" for=""> Short description</label>
                  <div class="custom-form-control">
                    <angular-editor formControlName="description" placeholder="Short description"
                      >
                    </angular-editor>
                    <!--<mat-error
                      *ngIf="description.invalid && ( description.dirty || description.touched )">
                      <span> Description is required </span>
                    </mat-error>-->
                  </div>
                </div>
                <!-- HTML_EDITOR_FIELD -->
                <div class="custom-form-group">
                  <label class="custom-label" for=""> Specifications </label>
                  <div class="custom-form-control">
                    <angular-editor formControlName="specifications" placeholder="specifications"
                      >
                    </angular-editor>
                    <!--<mat-error
                      *ngIf="specifications.invalid && ( specifications.dirty || specifications.touched )">
                      <span> Specifications is required</span>
                    </mat-error>-->
                  </div>
                </div>
              </div>
            </div>
             <!-- Specifications end-->
            </div>
          
          
          
<!--seo-->
            <div class="form_box">
              <h5>Seo</h5>
              <div class="" formGroupName="seo_metadata" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                            fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">
                            <div class="mobile_mn_0" fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50"
                              fxFlex.xs="100" fxFlexFill>
                           
                              <!-- Page Title-INPUT -->
                              <div class="custom-form-group">
                                <label class="custom-label" for=""> Title </label>
                                <div class="custom-form-control">
                                  <mat-form-field appearance="outline">
                                    <input matInput placeholder="Enter seo title" formControlName="title"
                                      (change)="trimMe(seo_title)">
                                    <!--<mat-error *ngIf="seo_title.invalid && ( seo_title.dirty || seo_title.touched )">
                                      <span>Title is required</span>
                                    </mat-error>-->
                                  </mat-form-field>
                                </div>
                              </div>
                              <!-- Meta Image-INPUT -->
                              <div class="custom-form-group">
                                <label class="custom-label" for="">Meta Image</label>
                                <div class="custom-form-control">
                                  <app-single-file-upload [fileInput]="seo_image" type="IMAGE"></app-single-file-upload>
                                </div>
                              </div>
                              <!-- Short Description-INPUT -->
                              <div class="custom-form-group">
                                <label class="custom-label" for="">Meta Description</label>
                                <div class="custom-form-control">
                                  <mat-form-field appearance="outline">
                                    <textarea matInput formControlName="description"
                                      placeholder="Enter meta description"
                                      (change)="trimMe(seo_description)"></textarea>
                                   <!-- <mat-error
                                      *ngIf="seo_description.invalid && ( seo_description.dirty || seo_description.touched )">
                                      <span>Meta description is required </span>
                                    </mat-error>-->
                                  </mat-form-field>
                                </div>
                              </div>
                            </div>
                            <div class="mobile_mn_0" fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50"
                              fxFlex.xs="100" fxFlexFill>
                              <!-- keyword-INPUT -->
                              <div class="custom-form-group">
                                <label class="custom-label" for=""> Keywords</label>
                                <div class="custom-form-control">
                                  <mat-form-field appearance="outline">
                                    <input type="text" matInput #keywordInput
                                      placeholder="Enter keyword and press enter button"
                                      (keydown)="saveKeyword($event)" />
                                  </mat-form-field>
                                  <mat-chip-list>
                                    <mat-chip [removable]="removable" *ngFor="let single of seo_keywords.value"
                                      (removed)="remove(single)">
                                      {{single}}
                                      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                    </mat-chip>
                                  </mat-chip-list>
                                  <!--<mat-error
                                    *ngIf="seo_keywords.invalid && ( seo_keywords.dirty || seo_keywords.touched )">
                                    Keywords required
                                  </mat-error>-->
                                </div>
                              </div>
                              <!-- Alt Text-INPUT -->
                              <div class="custom-form-group">
                                <label class="custom-label" for=""> Alt Text</label>
                                <div class="custom-form-control">
                                  <mat-form-field appearance="outline">
                                    <input matInput placeholder="Enter alt text" formControlName="alt_text"
                                      (change)="trimMe(seo_alt_text)">
                                    <!--<mat-error
                                      *ngIf="seo_alt_text.invalid && ( seo_alt_text.dirty || seo_alt_text.touched )">
                                      <span>Alternate text is required </span>
                                    </mat-error>-->
                                  </mat-form-field>
                                </div>
                              </div>
                            </div>
                          </div>
            </div>
<!--Seo end-->
<!--Freight Charge-->
            <div class="form_box">
              <h5>Freight Charge</h5>
              <div class="" formGroupName="freight_charge" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">
                <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100"
                  fxFlex.xs="100" fxFlexFill>
          
                  <!--Amount -INPUT -->
                  <div class="custom-form-group supplies_add_form">
                    <label class="custom-label" for=""> Type <span class="star">*</span></label>
                    <div class="custom-form-control featured_toggle">
                      <div class="custom-tabs">
                        <mat-button-toggle-group formControlName="type">
                          <mat-button-toggle value="RANGE"> Range </mat-button-toggle>
                          <mat-button-toggle value="FLAT"> Flat </mat-button-toggle>
                          <mat-button-toggle value="PICKUP"> Pickup only </mat-button-toggle>
                        </mat-button-toggle-group>
                        <mat-error *ngIf="type.invalid && ( type.dirty || type.touched )">
                          <span>Valid amount is required</span>
                        </mat-error>
                      </div>
                    </div>
                  </div>
                  <ng-container *ngIf="type.value ==='RANGE'">
                    <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                      fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch"
                      fxLayoutGap="15px">
                      <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50"
                        fxFlex.xs="50" fxFlexFill>
                        <!-- State-INPUT -->
                        <div class="custom-form-group">
                          <label class="custom-label" for=""> Select state<span class="star"
                              style="display: inline-block !important;">*</span></label>
                          <div class="custom-form-control">
                            <mat-form-field appearance="outline">
                              <mat-select formControlName="state_id" placeholder="Select State">
                                <mat-option *ngFor="let single of stateList" [value]="single.id">
                                  {{single.name}}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="state_id.invalid && ( state_id.dirty || state_id.touched )">
                                <span>Select state is required </span>
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <!-- <button type="button" mat-mini-fab color="accent"
                  aria-label="Button for deleting metro region section" (click)="plusMetroRegion()">
                  <mat-icon>add</mat-icon>
                </button> -->
                        <ng-container formArrayName="metro_regions">
                          <ng-container *ngFor="let single of metro_regions.controls;let i = index"
                            [formGroupName]="i">
                            <div class="supplies_add_form ">
                              <div class="add_supplies_row add_array_form">
                                <div class="add_vients_formarray pb-0">
                                  <!-- <button type="button" mat-mini-fab color="accent"
                              aria-label="Button for deleting suburban section" >
                              <mat-icon>remove</mat-icon>
                            </button> -->
                                  <div class="delete_array">
                                    <img src="../../../../../../../assets/images/icons/delete_primary.svg"
                                      alt="" (click)="minusMetroRegion(i)">
                                  </div>
                                  <!-- Metro Region -INPUT -->
                                  <div class="custom-form-group">
                                    <label class="custom-label" for=""> Select metro region<span
                                        class="star"
                                        style="display: inline-block !important;">*</span></label>
                                    <div class="custom-form-control">
                                      <mat-form-field appearance="outline">

                                        <mat-select formControlName="name" placeholder="Enter Metro region name">
                                          <mat-option value="metro">Metro</mat-option>
                                          <mat-option value="regional" >Regional</mat-option>
                                          <mat-option value="coastal">Coastal</mat-option>
                                        </mat-select>
                                        <mat-error
                                          *ngIf="getName(i).invalid && ( getName(i).dirty || getName(i).touched )">
                                          <span>Metro region is required </span>
                                        </mat-error>
                                      </mat-form-field>
                                    </div>
                                  </div>
                                  <!-- Sub urban -INPUT -->
                             <!--     <div class="custom-form-group">
                                    <label class="custom-label" for=""> Select Suburb {{thisSubUrbanList | json}}  </label>
                                    <div class="custom-form-control"
                                      *ngIf="suburbanList | suburban: state_id.value as thisSubUrbanList">
                                      <mat-form-field appearance="outline">
                                        <mat-select formControlName="pincodes" placeholder="Select suburban"
                                          multiple #matSelectDropdown>
                                          <mat-option #allSelected
                                            (click)="toggleAllSelection(getPincodes(i), thisSubUrbanList, allSelected)"
                                            [value]="0">All</mat-option>
                                          <mat-option *ngFor="let single of thisSubUrbanList"
                                            [value]="single.pincode"
                                            (click)="togglePerOne(getPincodes(i), thisSubUrbanList, allSelected)">
                                            {{single.name}} - {{single.pincode}} </mat-option>
                                          <button type="button" mat-button
                                            (click)="matSelectDropdown.close()">
                                            Close </button>
                                        </mat-select>
                                        <mat-error
                                          *ngIf="getPincodes(i).invalid && ( getPincodes(i).dirty || getPincodes(i).touched )">
                                          <span>Pincodes is required </span>
                                        </mat-error>
                                      </mat-form-field>
                                    </div>
                                  </div>--> 
                                  <!--Amount -INPUT -->
                                  <div class="custom-form-group">
                                    <label class="custom-label" for=""> Freight Amount<span class="star"
                                        style="display: inline-block !important;">*</span></label>
                                    <div class="custom-form-control">
                                      <mat-form-field appearance="outline">
                                        <input type="number" matInput placeholder="Enter freight amount"
                                          formControlName="amount">
                                        <mat-error
                                          *ngIf="getAmount(i).invalid && ( getAmount(i).dirty || getAmount(i).touched )">
                                          <span>Amount is required</span>
                                        </mat-error>
                                      </mat-form-field>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </ng-container>
                        <div class="">
                          <div class="add_supplies_row">
                            <div class=" supplies_add_form pb-10 pt-10">
                              <div class="add_vients_box p-0">
                                <p>Add region</p>
                                <button class="btn btn-sm global-btn mat-button" mat-button
                                  (click)="plusMetroRegion()">
                                  <img src="../../../../../../../assets/images/icons/add.svg" alt="">Add
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="type.value === 'FLAT'">
                    <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                      fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch"
                      fxLayoutGap="15px">
                      <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50"
                        fxFlex.xs="50" fxFlexFill>
                        <!--Amount -INPUT -->
                        <div class="custom-form-group">
                          <label class="custom-label" for=""> Freight Amount <span
                              class="star">*</span></label>
                          <div class="custom-form-control">
                            <mat-form-field appearance="outline">
                              <input type="number" matInput placeholder="Enter freight amount"
                                formControlName="amount">
                              <mat-error *ngIf="amount.invalid && ( amount.dirty || amount.touched )">
                                <span>Amount is required</span>
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="type.value === 'PICKUP'">
                    <div formGroupName="address" fxLayout="column" fxFlex.xl="100" fxFlex.lg="100"
                      fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100" fxFlexFill>
                      <div class="address-row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row"
                        fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
                        fxLayoutAlign="start stretch" fxLayoutGap="25px">
                        <div class="address-column" fxLayout="column" fxFlex.xl="50" fxFlex.lg="50"
                          fxFlex.md="50" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
                          <!-- First Name-SELECT -->
                          <div class="custom-form-group">
                            <label class="custom-label" for="">Name<span class="star"
                                style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control">
                              <mat-form-field appearance="outline">
                                <input type="text" matInput formControlName="short_name"
                                  placeholder="Enter name" (change)="trimMe(short_name)" />
                                <mat-error
                                  *ngIf="short_name.invalid && ( short_name.dirty || short_name.touched )">
                                  <span> Name is required</span>
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                          <!-- Address-INPUT -->
                          <div class="custom-form-group text-area-group">
                            <label class="custom-label" for="">Address Line 2</label>
                            <div class="custom-form-control">
                              <mat-form-field appearance="outline">
                                <textarea rows="2" cols="2" matInput formControlName="line_2"
                                  placeholder="Enter address line 2" (change)="trimMe(line_2)"></textarea>
                                <mat-error *ngIf="line_2.invalid && ( line_2.dirty || line_2.touched )">
                                  <span>Address is required</span>
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                          <!-- PHone No-INPUT -->
                          <div class="custom-form-group">
                            <label class="custom-label" for="">City<span class="star"
                                style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control">
                              <mat-form-field appearance="outline">
                                <input type="text" matInput placeholder="Enter city" formControlName="city"
                                  (change)="trimMe(city)">
                                <mat-error *ngIf="city.invalid && ( city.dirty || city.touched )">
                                  <span>City is required</span>
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                          <!-- Country-SELECT -->
                          <div class="custom-form-group">
                            <label class="custom-label" for="">Country<span class="star"
                                style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control">
                              <mat-form-field appearance="outline">
                                <mat-select placeholder="Select Country" formControlName="country">
                                  <mat-option disabled=""> Select country </mat-option>
                                  <mat-option value="Australia">Australia</mat-option>
                                </mat-select>
                                <mat-error *ngIf="country.invalid && ( country.dirty || country.touched )">
                                  <span>Country is required</span>
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                        <div class="address-column" fxLayout="column" fxFlex.xl="50" fxFlex.lg="50"
                          fxFlex.md="50" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
                          <!-- Address-INPUT -->
                          <div class="custom-form-group text-area-group">
                            <label class="custom-label" for="">Address Line 1<span class="star"
                                style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control">
                              <mat-form-field appearance="outline">
                                <textarea rows="2" cols="2" matInput formControlName="line_1"
                                  placeholder="Enter address line 1" (change)="trimMe(line_1)"></textarea>
                                <mat-error *ngIf="line_1.invalid && ( line_1.dirty || line_1.touched )">
                                  <span>Address is required</span>
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                          <!-- PHone No-INPUT -->
                          <div class="custom-form-group">
                            <label class="custom-label" for="">Landmark</label>
                            <div class="custom-form-control">
                              <mat-form-field appearance="outline">
                                <input type="text" matInput placeholder="Enter landmark"
                                  formControlName="landmark" (change)="trimMe(landmark)">
                                <mat-error
                                  *ngIf="landmark.invalid && ( landmark.dirty || landmark.touched )">
                                  <span>Landmark is required</span>
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                          <!-- State-SELECT -->
                          <div class="custom-form-group">
                            <label class="custom-label" for="">State<span class="star"
                                style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control">
                              <mat-form-field appearance="outline">
                                <mat-select placeholder="Select State" formControlName="state">
                                  <mat-option disabled=""> Select State </mat-option>
                                  <mat-option value="Australian Capital Territory">Australian Capital
                                    Territory</mat-option>
                                  <mat-option value="New south wales">New south wales</mat-option>
                                  <mat-option value="Northern Territory">Northern Territory</mat-option>
                                  <mat-option value="Queensland">Queensland</mat-option>
                                  <mat-option value="South australia">South australia</mat-option>
                                  <mat-option value="Western australia">Western australia</mat-option>
                                  <mat-option value="Victoria">Victoria</mat-option>
                                </mat-select>
                                <mat-error *ngIf="state.invalid && ( state.dirty || state.touched )">
                                  <span>State is required</span>
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                          <!-- Pincode-INPUT -->
                          <div class="custom-form-group">
                            <label class="custom-label" for="">Postalcode<span class="star"
                                style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control">
                              <mat-form-field appearance="outline">
                                <input matInput placeholder="Enter Post Code / ZIP"
                                  formControlName="postal_code" (change)="trimMe(postal_code)">
                                <mat-error
                                  *ngIf="postal_code.invalid && ( postal_code.dirty || postal_code.touched )">
                                  <span>Postal code is required</span>
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
<!--Freight Charge end-->





            <div class="form_box">
              <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
                <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50" fxFlex.xs="100"
                  fxFlexFill>
                  <!-- Product type-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for=""> Product type <span class="star">*</span></label>
                    <div class="custom-form-control featured_toggle">
                      <div class="custom-tabs">
                        <mat-button-toggle-group formControlName="product_type">
                          <mat-button-toggle value="ONLY_BIDING">Only biding </mat-button-toggle>
                          <mat-button-toggle value="ONLY_BUY_NOW">Only buy now</mat-button-toggle>
                          <mat-button-toggle value="BOTH"> Both </mat-button-toggle>
                        </mat-button-toggle-group>
                        <mat-error *ngIf="product_type.invalid && ( product_type.dirty || product_type.touched )">
                          <span> Product type is required</span>
                        </mat-error>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
                <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50" fxFlex.xs="100"
                  fxFlexFill>
                  <!-- Minimum Bid Value-INPUT -->
                  <div class="custom-form-group" *ngIf="['ONLY_BIDING', 'BOTH'].includes(product_type.value)">
                    <label class="custom-label" for="">Minimum Bid Value<span class="star"
                        style="display: inline-block !important;">*</span></label>
                    <div class="custom-form-control">
                      <div class="border_radius_none">
                        <mat-form-field appearance="outline">
                          <input type="number" matInput placeholder="Enter Minimum Bid Value"
                            formControlName="starting_price">
                          <mat-error
                            *ngIf="starting_price.invalid && ( starting_price.dirty || starting_price.touched )">
                            <span>Minimum bid value is required</span>
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <!-- Bid start date-INPUT -->
                  <div class="custom-form-group" *ngIf="['ONLY_BIDING', 'BOTH'].includes(product_type.value)">
                    <label class="custom-label" for="">Bid start date<span class="star"
                        style="display: inline-block !important;">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input type="datetime-local" matInput formControlName="bid_starts_at"
                          placeholder="Select bid starts at" [min]="idValue ? null: currentDate">
                        <mat-error *ngIf="bid_starts_at.invalid && ( bid_starts_at.dirty || bid_starts_at.touched )">
                          <span>Bid start date is required </span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <!--images-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for=""> Image <span class="star"
                        style="display: inline-block !important;">*</span></label>
                    <div class="custom-form-control">
                      <app-single-file-upload [fileInput]="image" type="IMAGE">
                      </app-single-file-upload>
                      <mat-error *ngIf="image.invalid && ( image.dirty || image.touched )">
                        <span>Image is required </span>
                      </mat-error>
                    </div>
                  </div>
                  <!--Variant Video-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for=""> Video <span class="star">*</span></label>
                    <div class="custom-form-control">
                      <app-single-file-upload [fileInput]="video" type="VIDEO">
                      </app-single-file-upload>
                    </div>
                  </div>
                </div>
                <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50" fxFlex.xs="100"
                  fxFlexFill>
                  <!-- {{buy_now_price.hasError('required')}} -->
                  <!-- Buy now price-INPUT -->
                  <div class="custom-form-group" *ngIf="['ONLY_BUY_NOW', 'BOTH'].includes(product_type.value)">
                    <label class="custom-label" for=""> Buy now price<span class="star"
                        style="display: inline-block !important;">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter buy now price" formControlName="buy_now_price">
                        <mat-error *ngIf="buy_now_price.invalid && ( buy_now_price.dirty || buy_now_price.touched )">
                          <span> Buy now price is required</span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Bid End date-INPUT -->
                  <div class="custom-form-group" *ngIf="['ONLY_BIDING', 'BOTH'].includes(product_type.value)">
                    <label class="custom-label" for="">Bid end date<span class="star"
                        style="display: inline-block !important;">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input type="datetime-local" matInput formControlName="bid_ends_at"
                          [min]="idValue ? bid_starts_at.value && currentDate: null" placeholder="Select bid ends at" />
                        <mat-error *ngIf="bid_ends_at.invalid && ( bid_ends_at.dirty || bid_ends_at.touched )">
                          <span>Bid end date is required</span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- color-INPUT -->
                  <div class="custom-form-group custom-color-group">
                    <label class="custom-label" for="">Color </label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        {{color.value}}
                        <input type="text" matInput placeholder="color " formControlName="color">
                        <mat-error *ngIf="color.invalid && ( color.dirty || color.touched )">
                          <span>Color is required</span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <!--Product images-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for=""> More Images </label>
                    <div class="custom-form-control">
                      <app-file-upload [fileInput]="more_images" type="IMAGE"></app-file-upload>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form_box">
              <div class="" fxLayout="column" fxLayoutAlign="end end">
                <div class="flex flex_btns">
                  <button type="submit" class="btn btn-sm global-btn mat-button" mat-button> Save as draft </button>
                  <button type="button" class="btn btn-sm global-btn mat-button" mat-button
                    (click)="addSupply('APPROVED')"> Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </section>
</section>
